import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";
import { MdStars } from "react-icons/md";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-indigo-900 to-black text-white py-4 px-6 flex justify-between items-center relative shadow-xl border-b border-gray-700">
      {/* Logo with Animated Icon */}
      <div className="flex items-center space-x-2 text-white text-2xl font-bold tracking-wide">
        <motion.div 
          animate={{ rotate: 360 }} 
          transition={{ repeat: Infinity, duration: 5, ease: "linear" }}
        >
          <MdStars className="text-yellow-400 text-3xl" />
        </motion.div>
        <a href="/" className="text-white no-underline">Pt. Kamlesh Sharma</a>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex space-x-8 text-lg font-medium">
        <a href="/" className="text-blue-400 hover:text-yellow-400 transition duration-300">Home</a>
        <a href="/about" className="text-white hover:text-gray-400 transition duration-300">About Us</a>
        <a href="/portfolio" className="text-white hover:text-gray-400 transition duration-300">Portfolio</a>
        <a href="/contact" className="text-white hover:text-gray-400 transition duration-300">Contact Us</a>
      </nav>

      {/* Icons & Mobile Menu Toggle */}
      <div className="flex items-center space-x-4">
        <FaSearch className="text-white cursor-pointer hover:text-gray-400 transition duration-300 text-xl" />
        <div className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <HiX className="text-white text-3xl cursor-pointer" /> : <HiMenu className="text-white text-3xl cursor-pointer" />}
        </div>
      </div>

      {/* Animated Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute top-16 left-0 w-full bg-black bg-opacity-90 backdrop-blur-lg text-white flex flex-col items-center py-8 space-y-6 md:hidden z-10 border-t border-gray-700"
          >
            <a href="/" className="text-blue-400 hover:text-yellow-400 text-lg font-semibold" onClick={() => setIsOpen(false)}>HOME</a>
            <a href="/about" className="text-white hover:text-gray-400 text-lg font-semibold" onClick={() => setIsOpen(false)}>ABOUT</a>
            <a href="/portfolio" className="text-white hover:text-gray-400 text-lg font-semibold" onClick={() => setIsOpen(false)}>PORTFOLIO</a>
            <a href="/contact" className="text-white hover:text-gray-400 text-lg font-semibold" onClick={() => setIsOpen(false)}>CONTACT</a>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
